import { render } from "./PriceProvide.vue?vue&type=template&id=0f8415a8&scoped=true"
import script from "./PriceProvide.vue?vue&type=script&lang=js"
export * from "./PriceProvide.vue?vue&type=script&lang=js"

import "./PriceProvide.vue?vue&type=style&index=0&id=0f8415a8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0f8415a8"

export default script